import { Suspense, useState } from 'react'
import * as S from './SideMenu.styles'
import MixtilesLogo, { LOGO_SRC } from '../../elements/TopBar/Logo/MixtilesLogo'
import MenuItems from './MenuItems/MenuItems'
import MenuFooter from './MenuFooter/MenuFooter'
import LoginSkeleton from '../LoginBox/LoginSkeleton/LoginSkeleton'
import SplashSpinnerOverlay from '../SplashSpinner/SplashSpinnerOverlay'
import { analytics, EVENT_NAMES } from '../../services/Analytics/Analytics'
import LoginBoxWrapper from '../LoginBox/LoginBoxWrapper.client'
import PromoCodeDialog from '../PromoCodeDialog/PromoCodeDialog.client'
import CreditBox from '../LoginBox/CreditBox'
import BrowserThemeColor from '../ThemeColor/BrowserThemeColor'
import { useTheme } from 'styled-components'
import { NavDivider } from './Divider.styles'
import NoSSR from 'utils/NoSSR'
import { useBlurActiveElementOnExit } from 'utils/mui-utils'

export default function SideMenu({ open, onDismiss }) {
  const [showPromoCodeDialog, setShowPromoCodeDialog] = useState(false)
  const theme = useTheme()

  useBlurActiveElementOnExit(open)

  const onLoginStart = () => {
    if (window.screen.width < 1440) {
      onDismiss()
    }
  }

  const handlePromoCodeClick = () => {
    setShowPromoCodeDialog(true)
    analytics.track(EVENT_NAMES.CHANGE_PROMO_CODE_TAPPED, {
      Trigger: 'Side Menu',
    })
    onDismiss()
  }

  return (
    <>
      <S.Drawer
        anchor="left"
        open={open}
        onClose={onDismiss}
        // disableEnforceFocus prop is meant to prevent unexpected behavior when something from the drawer pop up as a modal
        // for example PayPal window shown as a modal in 'in-app browsers' like Facebook App - that prevents user to use Paypal modal (cannot type there).
        // keepMounted is used in order to render the menu for SEO
        // disablePortal prevents rendering of the menu at the end of the <body>, so it will be rendered inside the top bar
        ModalProps={{
          disableEnforceFocus: true,
          keepMounted: true,
          disablePortal: false,
        }}
      >
        <BrowserThemeColor color={theme.colors.dialogGray} enabled={open} />
        <S.NavContainer>
          <S.TopContainer>
            <S.Logo>
              <MixtilesLogo source={LOGO_SRC.MENU} />
            </S.Logo>
            <S.CloseButton onClick={onDismiss} />
          </S.TopContainer>

          <S.MainNavContainer>
            <NoSSR>
              <Suspense fallback={<LoginSkeleton />}>
                <LoginBoxWrapper
                  source="Side Menu"
                  onLoginStart={onLoginStart}
                />
              </Suspense>
            </NoSSR>
            <NavDivider />
            <S.NavsContainer>
              <CreditBox />
              <MenuItems
                isOpen={open}
                onDismissMenu={onDismiss}
                onPromoCodeClick={handlePromoCodeClick}
              />
            </S.NavsContainer>
            <NavDivider />
            <MenuFooter />
          </S.MainNavContainer>
        </S.NavContainer>
      </S.Drawer>
      <Suspense fallback={<SplashSpinnerOverlay />}>
        {showPromoCodeDialog && (
          <PromoCodeDialog
            open={showPromoCodeDialog}
            onDismiss={() => setShowPromoCodeDialog(false)}
            source="Side Menu"
          />
        )}
      </Suspense>
    </>
  )
}
